import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    latitude: Number,
    longitude: Number,
    name: String
  }

  connect() {
    this._disconnected = false
    this.waitForGoogleMaps()
  }

  disconnect() {
    this._disconnected = true
  }

  waitForGoogleMaps() {
    if (this._disconnected) return

    if (typeof google !== "undefined" && google.maps) {
      this.initializeMap()
    } else {
      setTimeout(() => this.waitForGoogleMaps(), 100)
    }
  }

  async initializeMap() {
    try {
      const { Map } = await google.maps.importLibrary("maps")
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

      if (this._disconnected || !this.element.isConnected) return

      const position = { lat: this.latitudeValue, lng: this.longitudeValue }

      this.map = new Map(this.element, {
        center: position,
        zoom: 12,
        mapId: "trip-location-map",
        disableDefaultUI: true,
        zoomControl: true
      })

      new AdvancedMarkerElement({
        map: this.map,
        position: position,
        title: this.nameValue
      })
    } catch (error) {
      console.error("Error initializing map:", error)
    }
  }
}
